var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"privacy-policy-page"},[_c('PrivacyPolicy')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }